import { render, staticRenderFns } from "./bottom-navigation.vue?vue&type=template&id=4027e7a7&scoped=true&"
import script from "./bottom-navigation.ts?vue&type=script&lang=ts&"
export * from "./bottom-navigation.ts?vue&type=script&lang=ts&"
import style0 from "./bottom-navigation.scss?vue&type=style&index=0&id=4027e7a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4027e7a7",
  null
  
)

component.options.__file = "bottom-navigation.vue"
export default component.exports